import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Button from 'material-ui/Button';
import Dialog, { DialogActions, DialogContent, DialogContentText, DialogTitle, } from 'material-ui/Dialog';
import { FormControl } from 'material-ui/Form';
import Select from 'material-ui/Select';
import { MenuItem } from 'material-ui/Menu';
import Input, { InputLabel } from 'material-ui/Input';
import Slide from 'material-ui/transitions/Slide';
import moment from 'moment'

import filter from 'lodash/filter'

import * as deleteTeam from '../../../actions/teamdetails';
import { colorList } from '../../selectcolor'
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
import Table, {
    TableBody,
    TableCell,
    TableFooter,
    TableHead,
    TablePagination,
    TableRow,
    TableSortLabel,
} from 'material-ui/Table';

class AuditInfo extends Component {

    handleRequestClose = () => {
        this.props.closeDialog();
    };

    setData = () => {
        this.props.closeDialog();
        this.props.actions.deleteTeamDetails(Number(this.props.data.id));
    };

    render() {
        const { data, audittype } = this.props;
        console.log(data);

        if (data && data.meetingDate && data.meetingDate.indexOf('Z') > 0) {
            // data.meetingDate = moment(data.meetingDate).format('DD/MM/YYYY hh:mm');
            // console.log('popup meeting  date1 ', data.meetingDate);
            // if (data.meetingDate) {
            var sDate = moment(data.meetingDate).format('YYYY-MM-DD')

            var d = new Date(sDate + " " + data.meetingStartTime);
            // console.log('date value ',d)

            //     var sdate2 = moment(d).format('DD/MM/YYYY hh:mm a');
            //     console.log('popup meeting  date ', sdate2,sDate + " " + "13:23:00");
            // }
            //added by prabhakaran
            var sDate = moment(data.meetingDate).format('YYYY-MM-DD')

            var d = new Date(sDate + " " + data.meetingStartTime);
            data.meetingDate = moment(d).format('DD/MM/YYYY hh:mm a');
        }
        if (data && data.meetingEndDate && data.meetingEndDate.indexOf('Z') > 0) {
            // data.meetingEndDate = moment(data.meetingEndDate).format('DD/MM/YYYY hh:mm');

            //added by prabhakaran
            var sDate = moment(data.meetingEndDate).format('YYYY-MM-DD')
            var d = new Date(sDate + " " + data.meetingEndTime);
            data.meetingEndDate = moment(d).format('DD/MM/YYYY hh:mm a');
        }
        if (data && data.closevote && data.closevote.indexOf('Z') > 0)
            // data.closevote = moment(data.closevote).format('DD/MM/YYYY hh:mm');
            data.closevote = moment(data.closevote).format('DD/MM/YYYY');
        if (data && data.decisionDate && data.decisionDate.indexOf('Z') > 0)
            data.decisionDate = moment(data.decisionDate).format('DD/MM/YYYY');
        if (data && data.color) {
            let color = filter(colorList, ['value', data.color]);
            if (color && color.length > 0)
                data.color = color[0].label;
        }

        //Agenda Audit(with file)
        //File Name||Description||Priority

        //folder Audit (with file)
        //File Name||	Description||	Priority

        //resolution audit trial (with file)
        //File Name||	Description||	Priority


        // Decision Text||	Decision No	||Created By||IP Address

        // Agenda file audit


        //Folder file audit

        // res file audit


        var columnData, title;

        if (audittype == 'user') {
            title = "User Audit"
            columnData = [
                { title: "User Name :", data: "username" },
                { title: "UserId :", data: "userId" },
                { title: "email :", data: "email" },
                { title: "status :", data: "status" }
            ];

        } else if (audittype == 'meeting') {
            columnData = [
                { title: "Meeting Name :", data: "meetingName" },
                { title: "Location :", data: "location" },
                { title: "Start Date :", data: "meetingDate" },
                { title: "End Date :", data: "meetingEndDate" },
                // { title: "Start Time :", data: "meetingStartTime" },
                // { title: "End Time :", data: "meetingEndTime" },
                { title: "Draft/Publish :", data: "meetingStatus" },
                { title: "Meeting Status :", data: "status" }
            ];
        }
        else if (audittype == 'agenda') {
            columnData = [
                { title: "Agenda Item Name :", data: "agenda" },
                { title: "Headby :", data: "headedBy" },
                { title: "Color:", data: "color" },
                // { title: "Priority :", data: "priority" },
                { title: "Description :", data: "description" },
                { title: "notes :", data: "notes" },
                { title: "Status :", data: "status" }
            ];
        }
        else if (audittype == 'folder') {
            columnData = [
                { title: "Document Title :", data: "title" },
                { title: "Priority :", data: "priority" },
                { title: "Status :", data: "status" },
            ];
        }
        else if (audittype == 'resolutions') {
            columnData = [
                { title: "Name :", data: "name" },
                { title: "Headby :", data: "headedBy" },
                { title: "Color :", data: "color" },
                { title: "Description :", data: "description" },
                { title: "Close Date :", data: "closevote" },
                { title: "Status :", data: "status" },
            ];
        }
        else if (audittype == 'decisions') {
            columnData = [
                { title: "Decision Title :", data: "subject" },
                { title: "Decision Number :", data: "decisionNumber" },
                { title: "Decision Date :", data: "decisionDate" },
                { title: "Status : ", data: "status" }
            ];
        }
        else if (audittype == 'AgendaFile') {
            columnData = [
                { title: "File Name :", data: "name" },
                { title: "description :", data: "description" },
                { title: "order :", data: "orderLevel" },
                { title: "status :", data: "status" },

            ];
        }
        else if (audittype == 'folderFile') {
            columnData = [
                { title: "File Name :", data: "name" },
                { title: "description :", data: "description" },
                { title: "order:", data: "orderLevel" },
                { title: "status :", data: "status" }

            ];
        }
        else if (audittype == 'resolutionFile') {
            columnData = [
                { title: "File Name :", data: "name" },
                { title: "description :", data: "description" },
                { title: "order:", data: "orderLevel" },
                { title: "status :", data: "status" },
            ];
        }



        return (
            <div>
                <Dialog open={this.props.open} transition={Slide} onClose={this.handleRequestClose}>
                    <DialogTitle className="bg-primary">
                        <span className="text-white">Audit Info</span>
                    </DialogTitle>
                    <DialogContent>
                        <div className="row p-4">
                            <div className="col-md-12">
                                <Table className="">
                                    <TableBody>
                                        {
                                            columnData.map(column => {
                                                return (
                                                    <TableRow hover role="checkbox" tabIndex={-1}>
                                                        <TableCell padding="none">{column.title}</TableCell>
                                                        <TableCell padding="none"> </TableCell>
                                                        <TableCell padding="none">{data ? data[column.data] : ''}</TableCell>
                                                    </TableRow>
                                                )
                                            }, this)}

                                    </TableBody>
                                </Table>
                            </div>
                        </div>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleRequestClose} variant="raised" className="jr-btn bg-grey text-white">Cancel</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return state
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(deleteTeam, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(AuditInfo);


// WEBPACK FOOTER //
// ./app/auditdetails/AuditList/auditinfo.js